import dialogPolyfill from "../../node_modules/dialog-polyfill/dist/dialog-polyfill.esm.js";
import { SVGInjector } from "../../node_modules/@tanem/svg-injector/dist/svg-injector.esm.js";
import Odometer from "../../node_modules/odometer/odometer.js";

import "./step-up-and-own-it.js";
import "./lottie-animations.js";
import "./do-the-right-thing.js";
import "./moving-shapes.js";
import { AOS } from "./aos.js";

//#region Polyfill
document.querySelectorAll("dialog").forEach(dialog => {
  dialogPolyfill.registerDialog(dialog);
});
//#endregion Polyfill

//#region Animations
AOS.init({
  duration: 750,
  once: true
});

document.querySelectorAll("[data-aos=\"odometer\"]").forEach((el) => {
  el.addEventListener("aos:in", (event) => {
    const number = el.innerHTML;
    const odometer = new Odometer({
      el,
      value: 0,
      format: "",
    });

    el.innerHTML = number;
  });
});
//#endregion

//#region SVG Injector
SVGInjector(document.querySelectorAll("img[src$=\".svg\"].inline"), {
  afterAll(elementsLoaded) {
  },
  afterEach(err, svg) {
    if (err) {
      throw err
    }
  },
  beforeEach(svg) {

  },
});
//#endregion SVG Injector

function attachVideoEvents(video) {
  if (!video) {
    return;
  }

  const player = video.closest(".video-player");

  if (player) {
    video.addEventListener("play", (event) => {
      player.classList.toggle("playing", !video.paused);
      player.classList.toggle("paused", video.paused);
    });

    video.addEventListener("pause", (event) => {
      player.classList.toggle("playing", !video.paused);
      player.classList.toggle("paused", video.paused);
    });
  }
}

//#region Lightbox
const lightbox = /** @type HTMLDialogElement */ (document.getElementById("lightbox"));

const container = lightbox.querySelector("[method=dialog]");
const closeButton = lightbox.querySelector("[type=submit]");

function empty(element) {
  // Just in case it's faster to check for firstChild than lastChild
  // (e.g. if the element list is implemented as a directed linked-list by the UA).
  while (element.firstChild) {
    // In general, it's significantly faster to remove the last element of a collection
    // than it is to remove the first element.
    element.removeChild(element.lastChild);
  }
}

document.addEventListener("click", (event) => {
  const target = /** @type HTMLElement */ (event.target);
  const trigger = /** @type HTMLAnchorElement */ (target.closest("a[rel*=\"lightbox\"]"));

  if (trigger) {
    event.preventDefault();

    const container = lightbox.querySelector("[method=dialog]");
    const { pathname, href } = trigger;
    const ext = pathname.split(".").pop();
    let content;

    switch (ext) {
      case "mp4":
      case "webm":
      case "ogv":
        break;
      default:
        let width = (window.innerWidth * 0.95) | 0;
        if (width > 1200) width = 1200;
        let height = ((675 / 1200) * width) | 0;
        content = `<figure>
          <iframe width="${String(width)}" height="${String(height)}" src="${href}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </figure>`;
    }

    empty(container);
    container.insertAdjacentHTML("beforeend", content);
    container.appendChild(closeButton);
    lightbox.showModal();

    attachVideoEvents(lightbox.querySelector("video"));
  }
});

// Handle click on the backdrop to close the modal.
lightbox.addEventListener("click", event => {
  // Clicking on the backdrop.
  if (event.target == lightbox) {
    lightbox.close();
  }
});

lightbox.addEventListener("close", event => {
  empty(container);
});

document.addEventListener("click", (event) => {
  const target = /** @type HTMLElement */ (event.target);
  const video = /** @type HTMLVideoElement */ (target.closest("video:not([controls])"));

  if (video) {
    // toggles play / pause
    (video.paused || video.ended) ? video.play() : video.pause();
  }
});

document.querySelectorAll("video").forEach(attachVideoEvents);
